@if (fieldParameters.canAddNew) {
  <div class="edit-field-create-option-menu">
    <button
      mat-stroked-button
      (keyup)="createOptionWithKey($event)"
      (blur)="createOptionBlur()"
      type="button"
      (click)="createOption(); $event.stopPropagation();"
    >
      <mat-icon>
        add
      </mat-icon>

      <span>
        {{ 'TRANS__EDIT_FIELD_CREATE_OPTION_MENU__CREATE_NEW' | translate }}
      </span>
    </button>

    @if (reference?.search_kulturnav) {
      <button
        mat-stroked-button
        (click)="searchKulturNav(); $event.stopPropagation();"
        (keyup)="searchKulturNavWithKey($event)"
        (blur)="searchKulturNavBlur()"
        type="button"
      >
        <mat-icon>
          get_app
        </mat-icon>

        <span>
          {{ 'TRANS__EDIT_FIELD_CREATE_OPTION_MENU__GET_FROM_AUTHORITY' | translate }}
        </span>
      </button>
    }
  </div>
}
